import React from 'react';
import './Collections.css';
import { Availability, SetAvailabilityInput } from '../../client/core';

export interface LeadTimeProps {
    shopId?: string;
    availability: Availability;
    onChange: (availability: Availability) => void;
    onSave?: (input: SetAvailabilityInput) => void;
}

const LeadTime: React.FC<LeadTimeProps> = ({ shopId, availability, onChange, onSave }) => {
    const leadTimeHours = availability?.leadTimeHours ?? 0;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const hours = value === '' ? 0 : Math.max(0, parseInt(value, 10) || 0);

        onChange({
            ...availability,
            leadTimeHours: hours
        });
    };

    const handleSave = () => {
        if (onSave && shopId) {
            onSave({
                shopId,
                type: 'collection',
                availability
            });
        }
    };

    return (
        <div className="collections-container">
            <div className="collection-availability-section">
                <div className="section-header">
                    <h2>Lead Time</h2>
                    <button onClick={handleSave} className="save-button">
                        Save Lead Time
                    </button>
                </div>

                <div className="lead-time-editor">
                    <label className="lead-time-label">
                        <span className="lead-time-description">
                            Customers must place orders at least this many hours in advance:
                        </span>
                        <div className="lead-time-input-wrapper">
                            <input
                                type="number"
                                data-testid="lead-time-input"
                                className="lead-time-input"
                                value={leadTimeHours}
                                onChange={handleChange}
                                min={0}
                            />
                            <span className="lead-time-unit">hours</span>
                        </div>
                    </label>
                </div>
            </div>
        </div>
    );
};

export default LeadTime;
